<template>
  <div class="icon-cell">
    <i :class="iconClasses" />
  </div>
</template>

<script>
export default {
  name: "IconCell",
  props: {
    iconClasses: String
  }
};
</script>
